import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "sticky top-0 z-[900] flex min-h-16 items-center gap-3 border-b border-slate-300/30 bg-white/90 px-7 py-3 backdrop-blur max-md:px-3.5 max-md:py-2.5" }
const _hoisted_2 = { class: "flex min-h-[38px] items-center gap-2 rounded-full border border-slate-200 bg-slate-50 px-[13px] text-[13px] font-bold text-slate-700" }
const _hoisted_3 = { class: "flex min-h-[42px] items-center gap-2.5 rounded-full border border-slate-200 bg-white py-[3px] pl-[3px] pr-[13px] shadow-[0_8px_22px_rgba(15,23,42,0.06)]" }
const _hoisted_4 = ["title"]
const _hoisted_5 = { class: "flex flex-col leading-none" }
const _hoisted_6 = { class: "whitespace-nowrap text-xs font-extrabold text-slate-700" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("button", {
      type: "button",
      class: "hidden h-10 w-10 items-center justify-center rounded-lg border border-slate-300 bg-white text-slate-700 max-md:inline-flex",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('toggleSidebar')))
    }, [...(_cache[1] || (_cache[1] = [
      _createElementVNode("span", { class: "pi pi-bars" }, null, -1)
    ]))]),
    _createElementVNode("div", _hoisted_2, [
      _cache[2] || (_cache[2] = _createElementVNode("span", { class: "pi pi-clock mr-2" }, null, -1)),
      _createElementVNode("span", null, _toDisplayString($setup.nowText), 1)
    ]),
    _cache[3] || (_cache[3] = _createElementVNode("div", { class: "flex-1" }, null, -1)),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", {
        class: "flex h-9 w-9 items-center justify-center rounded-full bg-gradient-to-br from-teal-700 to-cyan-800 font-extrabold text-white",
        title: $setup.roleLabel
      }, _toDisplayString($setup.avatarText), 9, _hoisted_4),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, _toDisplayString($setup.roleLabel), 1)
      ])
    ])
  ]))
}